export const state = () => ({
  token: null,
  userData: null,
})

export const mutations = {
  setToken(state, token) {
    state.token = token
  },
  setUserData(state, userData) {
    state.userData = userData
  },
}

export const getters = {
  isLogged(state) {
    return !!state.token
  },
  userData(state) {
    return state.userData
  },
}
